import { SubscriptionFreightOptions } from "@modules/Models/SubscriptionFreightOptions";

export const GetDeliveryOptions = (subscriptionFreightOptions: SubscriptionFreightOptions[], subscriptionOptionId: string)=> {
    return subscriptionFreightOptions?.find((s) => s.id === subscriptionOptionId)?.deliveryOptions;
}